import { ConfigState, initialState } from './config.state';
import { ACTION_TYPES } from './config.action';
import { SUCCESS } from 'app/shared/util/action-type.util';

// Reducer
export default (state: ConfigState = initialState, action): ConfigState => {
  switch (action.type) {
    case ACTION_TYPES.GET_CONFIG: {
      return {
        ...state,
        countries: action.payload.countries,
        steps: action.payload.steps,
        title: action.payload.title,
        isReady: true,
        isWithoutOffer: action.payload.isWithoutOffer
      };
    }
    case ACTION_TYPES.GET_INFOS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case ACTION_TYPES.GET_AUTH_INFO: {
      return {
        ...state,
        issuer: action.payload.issuer,
        clientId: action.payload.clientId
      };
    }
    case SUCCESS(ACTION_TYPES.GET_PROFILE): {
      const { data } = action.payload;
      return {
        ...state,
        inProduction: data.activeProfiles.includes('prod'),
        isSwaggerEnabled: data.activeProfiles.includes('swagger')
      };
    }

    default:
      return state;
  }
};
